import axios from "axios";
import config from "../config/constants";
import { toastr } from "react-redux-toastr";
import {loadProcessToken } from "../actions/index";

const BASE_URL = config.PROJECT_DASHBOARD_API_URL + "aiservice";
export const LOAD_JOB = "LOAD_JOB";
export const UPDATE_JOB = "UPDATE_JOB";
export const CREATE_JOB = "CREATE_JOB";
export const TERMINATE_JOB = "TERMINATE_JOB";

export const LOAD_JOB_INFO = "LOAD_JOB_INFO";
export const LOAD_JOB_LOG = "LOAD_JOB_LOG";

export const ERROR = "ERROR";

export const loadJob = (props, scope) => {
  console.log("Loading Jobs");
 let token = loadProcessToken();
  return (dispatch, getState) => {
    let { selected_project } = getState();
    axios
      .get(`${BASE_URL}/jobs?projectId=${selected_project._id}`)
      .then(({ data }) => {
        console.log("Received Jobs");
        let newData = data.map((job) => {
             if (job.parameters) {
                let parameters = job.parameters;
                let modifiedParameters = [];
                for (let key_name in parameters) {
                  if (key_name != "job_name"){
                    modifiedParameters.push({ key: key_name, value: parameters[key_name] });
                  }
                }
                job.parameters = modifiedParameters;
             }
             return job;
        });
        console.log("Modified Jobs", newData);
        dispatch({
          type: LOAD_JOB,
          payload: newData
        });
      })
      .catch(function(error) {
        dispatch({
          type: ERROR,
          payload: { type: "danger", message: "Invalid Credentials" }
        });
      });
  };
};

export const loadJobInfo = (props, scope) => {
  let token = loadProcessToken();
  console.log(props, scope);
  let {projectId, formType} = props;
  return (dispatch, getState) => {
    axios
      .get(`${BASE_URL}/jobs/info?projectId=${projectId}`)
      .then(({ data }) => {
          let job = props;
          job["jobDefinitions"]=data["jobDefinitions"];
          job["queues"]=data["queues"]["jobQueues"];
          console.log("JOB INFO", job);
          dispatch({
            type: LOAD_JOB_INFO,
            payload: job
          });
      })
      .catch(function(error) {
        dispatch({
          type: ERROR,
          payload: { type: "danger", message: "Invalid Credentials" }
        });
      });
  };
};

export const loadJobLog = (props, scope) => {
  let token = loadProcessToken();
  console.log("LOADING JOB LOG");
  console.log(props, scope);
  let {arn,  logStreamName} = props;
  return (dispatch, getState) => {
    let url = `${BASE_URL}/jobs/log?arn=${arn}`;
    if (logStreamName){
        url =`${BASE_URL}/jobs/log?arn=${arn}&logStreamName=${logStreamName}`;
    }
    axios.get(url)
      .then(({ data }) => {
        dispatch({
          type: LOAD_JOB_LOG,
          payload: data
        });
      })
      .catch(function(error) {
        dispatch({
          type: ERROR,
          payload: { type: "danger", message: "Invalid Credentials" }
        });
      });
  };
};


export const createOrUpdateJob = (props, scope) => {
  let token = loadProcessToken();
  let { parameters, _id } = props;
  if (parameters) {
    let modifiedParameters = {};
    for (let parameter of parameters) {
      modifiedParameters[parameter.key] = parameter.value;
    }
    props.parameters = modifiedParameters;
  }
  if (_id) {
    return (dispatch, getState) => {
      axios
        .put(`${BASE_URL}/jobs?id=${_id}`, props)
        .then(({ data }) => {
          dispatch({
            type: UPDATE_JOB,
            payload: data
          });

          toastr.success("Successfully update the Job Definition");
        })
        .catch(function(error) {
          toastr.error(
            "Failed to update Job Definition",
            "Please check the inputs"
          );
        });
    };
  } else {
    return (dispatch, getState) => {
      axios
        .post(`${BASE_URL}/jobs`, props)
        .then(({ data }) => {
          dispatch({
            type: CREATE_JOB,
            payload: data
          });
          toastr.success("Successfully submitted the job");
        })
        .catch(function(error) {
          console.log("ERROR RESPONSE");
          if (error.response) {
               console.log(error.response);
               if (error.response.data){
                  if (error.response.data.Title) {
                      toastr.error('Failed to submit job', error.response.data.Title);
                  } else {
                      toastr.error('Failed to submit job', error.response.data);
                  }
               } else if (error.response){
                  toastr.error('Failed to submit job', error.response);
               }
          } else {
              toastr.error(
                "Failed to submit job",
                "Please check the inputs"
              );
          }
        });
    };
  }
};

export const terminateJob = (props, scope) => {
  let token = loadProcessToken();
  return (dispatch, getState) => {
    axios
      .post(`${BASE_URL}/jobs/terminate`, props)
      .then(({ data }) => {
        dispatch({
          type: TERMINATE_JOB,
          payload: data
        });
        toastr.success("Successfully terminated the job!");
      })
      .catch(function(error) {
           if (error.response.data){
                  if (error.response.data.Title) {
                      toastr.error('Failed to terminate the Job!', error.response.data.Title);
                  } else {
                      toastr.error('Failed to terminate the Job!', error.response.data);
                  }
           } else {
               toastr.error("Failed to terminate the Job!", "Please check the inputs");
           }
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/job.js